export const FILMS = [
  {
    id: "wedding-trailer",
    title: "Сватбен Трейлър",
    year: "2026",
    duration: "СВАТБЕН ФИЛМ",
    camera: "ARRI ALEXA 35",
    category: "КИНЕМАТОГРАФИЯ · СВАТБА",
    image: "https://i.vimeocdn.com/video/2221405066-52ac7ad0cb6eff0f3a35bd4fde9dabf51a7d7bc64f7dd55f21ff93c910208b2b-d_1280x720?region=us",
    vimeo: "https://player.vimeo.com/video/1242993658?title=0&byline=0&portrait=0&badge=0&autopause=0&autoplay=1&app_id=58479",
  },
  {
    id: "krosnarov",
    title: "Бизнес Рийл",
    year: "2026",
    duration: "БРАНД ФИЛМ",
    camera: "SONY VENICE 2",
    category: "РЕКЛАМА · БРАНД ФИЛМ",
    image: "https://i.vimeocdn.com/video/2221401455-a73ad22f2ce01727fb5ef170763c530fffc8b93f2bc64452e48dc2ffe863e12a-d_1280x720?region=us",
    vimeo: "https://player.vimeo.com/video/1242993597?title=0&byline=0&portrait=0&badge=0&autopause=0&autoplay=1&app_id=58479",
  },
  {
    id: "xiaomi-reel",
    title: "Бранд Рийл",
    year: "2026",
    duration: "РИЙЛ",
    camera: "9:16",
    category: "РЕКЛАМА · БРАНД РИЙЛ",
    image: "https://i.vimeocdn.com/video/2221395019-7f65a852370610854dcf1686ca8954190566417c4cd1b3d083ea1d12bcff33d6-d_1280x720?region=us",
    vimeo: "https://player.vimeo.com/video/1242993875?title=0&byline=0&portrait=0&badge=0&autopause=0&autoplay=1&app_id=58479",
  },
  {
    id: "rodopski-polah",
    title: "Евент Трейлър",
    year: "2025",
    duration: "МЕЛЕТО",
    camera: "RED KOMODO",
    category: "ДОКУМЕНТАЛЕН",
    image: "https://i.vimeocdn.com/video/2221390833-8c1156b3536ae64b719496033f3b6ed592aee1cc08b57a921ac141ee0aee7566-d_1280x720?region=us",
    vimeo: "https://player.vimeo.com/video/1242992882?title=0&byline=0&portrait=0&badge=0&autopause=0&autoplay=1&app_id=58479",
  },
  {
    id: "promo",
    title: "Promo",
    year: "2025",
    duration: "ПРОМО",
    camera: "35 мм",
    category: "ПРОМОЦИОНАЛЕН",
    image: "https://i.vimeocdn.com/video/2221388032-acf2e8bf2e93871ef7fc88471d1a615e19ce414aad29f9fb9fd6c400ff39a51c-d_1280x720?region=us",
    vimeo: "https://player.vimeo.com/video/1242989089?title=0&byline=0&portrait=0&badge=0&autopause=0&autoplay=1&app_id=58479",
  },
  {
    id: "clothing-brand",
    title: "Clothing Brand Promo",
    year: "2025",
    duration: "МОДЕН ФИЛМ",
    camera: "ALEXA MINI LF",
    category: "РЕЖИСУРА · МОДЕН ФИЛМ",
    image: "https://i.vimeocdn.com/video/2038937984-655ed9405d25b98d6e3af8e503eb5ec1c13332df4e86602b3f8f91cee9dfd55f-d_1280x720?region=us",
    vimeo: "https://player.vimeo.com/video/1103021877?badge=0&autopause=0&autoplay=1&app_id=58479",
  },
  {
    id: "kyrgyzstan",
    title: "Киргизстан — Страна на контрасти",
    year: "2025",
    duration: "ДОКУМЕНТАЛЕН",
    camera: "SONY A7S III",
    category: "ДОКУМЕНТАЛЕН",
    image: "https://i.ytimg.com/vi/9AHLix-fFkE/maxresdefault.jpg",
    vimeo: "https://www.youtube-nocookie.com/embed/9AHLix-fFkE?autoplay=1&rel=0",
  },
];

export const BRANDS = [
  { id: "xiaomi", name: "Xiaomi", city: "БЕРЛИН", x: 46, y: 20, projects: 12, video: "/videos/xiaomi.mp4", poster: "", logo: "/logos/xiaomi.png" },
  { id: "tehnomix", name: "Technomix", city: "СОФИЯ", x: 68, y: 32, projects: 9, video: "/videos/tehnomix.mp4", poster: "", logo: "/logos/tehnomix.jpeg" },
  { id: "styler", name: "Styler", city: "МИЛАНО", x: 28, y: 40, projects: 7, video: "/videos/styler.mp4", poster: "", logo: "/logos/styler.jpeg" },
  { id: "366", name: "366.bg", city: "ВАРНА", x: 70, y: 50, projects: 8, video: "/videos/36.6.mp4", poster: "", logo: "/logos/366.png" },
  { id: "lazarini", name: "Lazarini", city: "ПЛОВДИВ", x: 40, y: 60, projects: 5, video: "/videos/lazarini.mp4", poster: "", logo: "/logos/lazarini.jpeg" },
  { id: "inclusive", name: "Inclusive", city: "СОФИЯ", x: 62, y: 62, projects: 6, video: "/videos/inclusive.mp4", poster: "", logo: "/logos/inclusive.png" },
  { id: "tepe-dzhambore", name: "Тепе Джамборе", city: "РОДОПИТЕ", x: 26, y: 18, projects: 4, video: "/videos/tepe-dzhambore.mp4", poster: "", logo: "/logos/tepe-dzhambore.png" },
  { id: "promesa", name: "Promesa", city: "СОФИЯ", x: 30, y: 74, projects: 5, video: "/videos/promesa.mp4", poster: "", logo: "/logos/promesa.png" },
  { id: "rena", name: "Rena Couture", city: "СОФИЯ", x: 74, y: 16, projects: 4, video: "/videos/rena.mp4", poster: "", logo: "/logos/rena.png" },
];

export const PACKAGES = [
  {
    id: "reel",
    testid: "pricing-card-reel",
    name: "Рийл",
    price: "200 €",
    per: "НА РИЙЛ",
    desc: "Заснемане и обработка на кратък вертикален клип за Instagram, TikTok и YouTube Shorts.",
    features: ["Заснемане с камера и осветление", "Монтаж и цветова корекция", "Музика и субтитри", "Доставка във формат 9:16"],
  },
  {
    id: "wedding",
    testid: "pricing-card-wedding",
    name: "Сватба",
    price: "400 €",
    per: "ТРЕЙЛЪР ЗА СВАТБА",
    desc: "Кинематографичен трейлър с най-силните моменти от деня ви, а при нужда и пълен сватбен филм.",
    features: ["Заснемане на ключовите моменти", "Монтаж и цветова корекция", "Лицензирана музика", "Доставка в 4K", "Сватбен филм: 1 200 € (с двама оператори)"],
    featured: true,
  },
  {
    id: "production",
    testid: "pricing-card-production",
    name: "Продукция",
    price: "По договаряне",
    per: "МЕСЕЧНО СЪДЪРЖАНИЕ",
    desc: "Продукция от край до край за кампании, документални и дългометражни проекти.",
    features: ["Екип и кастинг", "Многодневни снимки", "Постпродукция", "Доставка в различни формати"],
  },
];

export const MARQUEE_ITEMS = [
  { platform: "INSTAGRAM", month: "ОКТОМВРИ" },
  { platform: "YOUTUBE", month: "СЕПТЕМВРИ" },
  { platform: "VIMEO", month: "АВГУСТ" },
  { platform: "INSTAGRAM", month: "ЮЛИ" },
  { platform: "TIKTOK", month: "ЮНИ" },
];

export const CREDITS = [
  { role: "ТВОРЧЕСКО РЪКОВОДСТВО", names: ["Леа Маршан", "Себастиан Фогел"] },
  { role: "СЕЛЕКЦИЯ", names: ["Alex Cholakov"] },
  { role: "ЛОКАЦИИ", names: ["Studio Noir", "Atelier Berlin"] },
  { role: "ФОТОГРАФИЯ", names: ["Различни автори"] },
  { role: "ТЕХНИКА", names: ["Alex Cholakov"] },
  { role: "ПАРТНЬОРИ", names: ["Pandora Films", "Constantin Film", "EuropaCorp", "Searchlight Pictures"] },
];

export const HERO_IMAGE = "https://images.unsplash.com/photo-1543990481-ac09b896dbbb?crop=entropy&cs=srgb&fm=jpg&q=85";
export const SHOWREEL = "/videos/showreel.mp4";
